import { render, staticRenderFns } from "./PortcallDetails.vue?vue&type=template&id=a8bd6652&scoped=true&"
import script from "./PortcallDetails.vue?vue&type=script&lang=js&"
export * from "./PortcallDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortcallDetails.vue?vue&type=style&index=0&id=a8bd6652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bd6652",
  null
  
)

export default component.exports